<template>
    <ul>
        <li v-bind:class="{ checked: record.checked, progress: !record.checked, 'w-tooltip': record.tooltips, current: record.inProgress }" v-for="record in list">
            <div class="before"></div>
            <div class="checkmark">
                <SvgIcon icon="checkmark"/>
            </div>
            <p>{{ $t(record.label) }}</p>

            <template v-if="record.tooltips">
                <div class="tool-tip"
                     v-if="record.tooltips.multiple || (!record.tooltips.multiple && record.checked)"
                     :class="{'multiline-tooltip ': record.tooltips.multiple === true}">
                    <span class="arrow-right"></span>
                    <div v-if="!record.tooltips.multiple" class="tooltip-item">
                        <span>{{ record.tooltips.text }}</span>
                    </div>
                    <div v-else v-for="item in record.tooltips.items" class="tooltip-item">
                        <div class="checkmark" :class="{checked: item.checked,unchecked: !item.checked}">
                            <SvgIcon icon="checkmark"/>
                        </div>
                        <span>{{ item.text }}</span>
                    </div>
                </div>

            </template>
        </li>
    </ul>
</template>

<script>
import SvgIcon from './Svg';

export default {
    components: {
        SvgIcon
    },
    props: [
        'list'
    ]

}
</script>


<style lang="scss">

</style>
